export const SALE_DATE_FILTER = {
  field: 'close_date',
  label: 'saleDate',
  operator: '>=',
  value: ''
}
